import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = () => ({
    latestActivityContainer: css({
        boxSizing: "border-box",
        padding: 24,
        width: "100%",
        height: 300,
        backgroundColor: Color.primary[900],
    }),
    latestActivityListContainer: css({
        maxHeight: 201,
        overflowY: "scroll"
    }),
    latestActivityList: css({
        width: "100%",
        display: "inline-flex",
        alignItems: "center",
        height: 67,
        transition: "all .2s ease-in-out",
        "&:hover": {
            backgroundColor: Color.primary[800]
        }
    }),
    activityListPicture: css({
        width: 40,
        height: 40,
        borderRadius: "50%",
        marginLeft: 16,
        backgroundColor: Color.neutral[100]
    }),
    activityListName: css({
        marginLeft: 18,
        width: 192,
        textOverflow: "ellipsis"
    }),
    activityListInfo: css({
        marginLeft: 35,
        width: 400,
        textOverflow: "ellipsis"
    }),
    activityListDate: css({
        width: 115,
        textOverflow: "ellipsis"
    }),
    activityListTime: css({
        marginLeft: 105,
        width: 70,
        textOverflow: "ellipsis"
    }),
    activityListAction: css({
        marginLeft: 16,
    })
});
